import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import store, { brokerActions } from '@apply/adminStore';
import { useBrokerDetailsStore } from '../../state/brokerDetailsStore';
import { useBrokerSettingsQuery } from '../../queries/brokerDetailsQueries';
import { brokerTitles } from '../../../../common/SharedConstants';

interface UseBrokerSettingsFormInitReturn {
    isLoading: boolean;
}

export const useBrokerSettingsFormInit = (): UseBrokerSettingsFormInitReturn => {
    /* eslint-disable @typescript-eslint/no-explicit-any */
    // Redux state is typed as any
    const bfiUser = useSelector((state: any) => state.bfiUser);
    const brokerId = useSelector((state: any) => state.brokerState?.brokerId);
    /* eslint-enable @typescript-eslint/no-explicit-any */

    const { data: brokerSettings, isLoading } = useBrokerSettingsQuery(brokerId);

    // Initialization: user context, eSign HTML, lists
    useEffect(() => {
        const s = useBrokerDetailsStore.getState();
        s.updateFields({ brokerId });

        const init = async () => {
            if (bfiUser.isBroker) {
                store.dispatch(brokerActions.setBrokerId({ brokerId: bfiUser.broker.id }));
            }
        };

        init();

        return () => {
            useBrokerDetailsStore.getState().reset();
        };
    }, []);

    // Initialize form from broker data
    useEffect(() => {
        useBrokerDetailsStore.getState().initializeFromBrokerSettings(brokerSettings, {
            isAdmin: bfiUser.admin,
            isBroker: bfiUser.isBroker,
            brokerId,
            brokerTitles,
        });
    }, [brokerSettings]);

    return { isLoading };
};
